import type { GemsApi_StoneShape } from '@/graphql/api'
import { includes } from '@/helpers'

export const allowedShapes = [
    'ASSCHER',
    'CUSHION',
    'EMERALD',
    'HEART',
    'HEXAGONAL',
    'MARQUISE',
    'OVAL',
    'PEAR',
    'PRINCESS',
    'RADIANT',
    'ROUND',
] as const satisfies Readonly<GemsApi_StoneShape[]>

export type AllowedStoneShape = (typeof allowedShapes)[number]

export function isGemsApiAllowedShape(shape: any): shape is AllowedStoneShape {
    return includes(allowedShapes, shape)
}
